export default __webpack_public_path__ + "static/media/nav_logo.46d86aac.png";